export default import.meta.ROLLDOWN_FILE_URL_qOFvC4bURbPTAYCRLdBhvw